import React from 'react';
import Map from 'ol/Map';

interface MapContextType {
  map: Map | null;
  setMap: (map: Map | null) => void;
}

const MapContext = React.createContext<MapContextType | undefined>(undefined);

export const MapProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [map, setMap] = React.useState<Map | null>(null);

  return (
    <MapContext.Provider value={{ map, setMap }}>
      {children}
    </MapContext.Provider>
  );
};

export const useMap = () => {
  const ctx = React.useContext(MapContext);
  if (!ctx) throw new Error('useMap must be used within MapProvider');
  return ctx;
};
